// Handles standard Create Read Update Delete actions in reducer
// dispatched by xtractAPI

const handleCRUD = (action, originals, idName) => {
  let newData
  if (originals == null) {
    newData = []
  } else if (Array.isArray(originals)) {
    newData = [...originals]
  } else {
    newData = [originals]
  }
  // newData is originals and is always an array now
  const pathArr = action.type.split('_')
  const suffix = pathArr.pop()
  switch (suffix) {
    case 'PARTIAL':
    case 'CREATE':
    case 'READ':
    case 'UPDATE':
      if (!Array.isArray(action.result)) {
        newData = handleSingleUpdate(newData, action.result, action.ids, idName)
      } else {
        action.result.forEach((newItem) => {
          newData = handleSingleUpdate(newData, newItem, action.ids, idName)
        })
      }
      return [...newData]
    case 'SEARCH':
    case 'ALL':
      return [...action.result]
    case 'DELETE':
      newData =
        (originals || []).filter((item) => {
          return item[idName] !== action.result[idName]
        }) || []
      return [...newData]
    default:
      return [...originals]
  }
}
export default handleCRUD

const handleSingleUpdate = (originals, result, ids, idName) => {
  let found = false
  let newData = []
  if (Array.isArray(originals)) {
    // as if this weren't complicated enough...
    // there are some cases where an update will actually cause the original
    // item to be deleted and a new copy to be returned. In this case
    // the result.idName value will be different than the idName value that
    // was provided to the url (update treatment_plan/7 returns a new
    // treatment_plan with id 8 and 7 is marked deleted). We can see if this has
    // happened by comparing result.idName to action.ids.idName. If
    // action.ids.idName is set and is different then result, we need to remove
    // the element with action.ids.idName (the one marked deleted) and add
    // the new result element. Otherwise we just do normal behavior.
    let idToReplace = null
    if (ids != null && ids[idName] != null && result[idName] !== ids[idName]) {
      // this is a mark deleted and add new case
      idToReplace = ids[idName]
    } else {
      // here we are using the id returned by the api... this should
      // always be the same as the one used in the url in this case meaning
      // that in theory we could ALWAYS use the case above. However
      // before this split was made, this is the ID that 99% of the code was
      // using so i'm adding this case so that we only use a different id when we
      // absolutly need to in an effort not to introduce unexpected bugs.
      idToReplace = result != null ? result[idName] : null
    }
    newData = originals.map((element) => {
      if (element[idName] != idToReplace) {
        return element
      } else {
        found = true
        return result
      }
    })
  }
  // If it wasn't in the array to replace just put it at the end
  if (!found && result != null && result[idName] != null) {
    newData.push(result)
  }
  return [...newData]
}
